import React from 'react';

import { useTranslation } from '@mint-lib/i18n';
import {
  ConfirmationDialog,
  ConfirmationDialogAction,
  ConfirmationDialogCancel,
  ConfirmationDialogContent,
  ConfirmationDialogDescription,
  ConfirmationDialogFooter,
  ConfirmationDialogHeader,
  ConfirmationDialogOverlay,
  ConfirmationDialogPortal,
  ConfirmationDialogRoot,
  ConfirmationDialogTitle,
  typographyVariants,
} from '@mint-lib/tw-components';

import { useDeleteScheduledQueries } from '../../../hooks/useDeleteScheduledQueries.jsx';

const DeleteQueriesDialog = () => {
  const { t } = useTranslation('@mint-lib/ai-chat');
  const {
    isOpenDeleteDialog,
    setIsOpenDeleteDialog,
    scheduledQueryIds,
    deleteScheduledQueries,
  } = useDeleteScheduledQueries();

  return (
    <ConfirmationDialog
      open={isOpenDeleteDialog}
      onOpenChange={setIsOpenDeleteDialog}
    >
      <ConfirmationDialogPortal>
        <ConfirmationDialogOverlay />
        <ConfirmationDialogRoot>
          <ConfirmationDialogHeader>
            <ConfirmationDialogTitle>
              {t(`Delete {{file}} file?`, { file: scheduledQueryIds?.length })}
            </ConfirmationDialogTitle>
          </ConfirmationDialogHeader>
          <ConfirmationDialogContent>
            <ConfirmationDialogDescription>
              <p className={typographyVariants({ variant: 'bodyLong01' })}>
                {t(
                  'If you proceed, you will permanently remove the selected file from our system. All data related to this query will be permanently deleted from the Scheduled queries.',
                )}
              </p>
            </ConfirmationDialogDescription>
          </ConfirmationDialogContent>
          <ConfirmationDialogFooter>
            <ConfirmationDialogCancel>{t('Cancel')}</ConfirmationDialogCancel>
            <ConfirmationDialogAction
              color="error"
              onClick={deleteScheduledQueries}
            >
              {t('Yes, delete')}
            </ConfirmationDialogAction>
          </ConfirmationDialogFooter>
        </ConfirmationDialogRoot>
      </ConfirmationDialogPortal>
    </ConfirmationDialog>
  );
};

export { DeleteQueriesDialog };
